// extracted by mini-css-extract-plugin
export default {"form":"Form-module__form--Nnzq_","privacy-policy-richtext":"Form-module__privacy-policy-richtext--LgM3L"};